<template>
  <EmailLoader>
    <p>A password reset was requested for your account.</p>
    <p>If you did not authorize this, you should contact us immediately!</p>

    <p>To continue with your password reset, simply click on the button below to reset your password!</p>

    <div class="text-center">
      <b-button variant="primary">
        Reset Password
      </b-button>
    </div>
  </EmailLoader>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import EmailLoader from '../setup/loader.vue'

export default {
  components: {
    BButton,
    EmailLoader,
  },
}
</script>
